import CryptoJS from "crypto-js";

const ENCRYPTION_SECRET = process.env.REACT_APP_ENCRYPTION_SECRET || "clave_segura_123";

// Cifrar
export const encryptData = async (data) => {
  const iv = CryptoJS.lib.WordArray.random(16);
  const key = CryptoJS.SHA256(ENCRYPTION_SECRET).toString(CryptoJS.enc.Hex);
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Hex.parse(key), {
    iv,
    mode: CryptoJS.mode.CBC,
  });
  return {
    iv: iv.toString(CryptoJS.enc.Base64),
    data: encrypted.toString(),
  };
};

// Descifrar
export const decryptData = async (encryptedData) => {
  const iv = CryptoJS.enc.Base64.parse(encryptedData.iv);
  const key = CryptoJS.SHA256(ENCRYPTION_SECRET).toString(CryptoJS.enc.Hex);
  const decrypted = CryptoJS.AES.decrypt(encryptedData.data, CryptoJS.enc.Hex.parse(key), {
    iv,
    mode: CryptoJS.mode.CBC,
  });
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};
